import React,{useState,useEffect} from "react";
import {facilitySlotActions, paketinActions, useSelector} from "inbooma-api";
import t from "../../../helpers/t";
import {Biscuit} from "../../../../utils";
import showNotification from "../../../helpers/showNotification";
import {moment} from "../../../../../vendor";
import FormItem from "../../../components/FormItem";

const SlotsItemView = (props) => {
    const {slot, facility, dispatch, returnPath, language, resources, name} = props;
    const [facilitySlot, setFacilitySlot] = useState(
        slot !== null? slot: {
            facility_id: facility.id,
            resource_id: null,
            external_resource_id: null,
            facility_slot_nbr: 1,
            status: 'active',
            error_code: null,
            error_text: null,
            charging_state: null,
            charging_quality: null,
            lock_open: null,
            slot_external_id: null
        }
    );
    const _facilitySlot = useSelector(state => state.facilitySlots.facilitySlot);

    const _createLock = useSelector(state => state.paketins_data.createLock);
    const [createLockVisible, setCreateLockVisible] = useState(false);
    const [createLockPending, setCreateLockPending] = useState(false);
    const lockTexts = {true:t('close create lock'),false:t('show create lock')};
    const [lockVisibleButtonText, setLockVisibleButtonText] = useState(lockTexts[false]);
    const [boxGroupId, setBoxGroupId] = useState('');
    const [lockerId, setLockerId] = useState('');
    const [action, setAction] = useState(typeof facilitySlot.id !== 'undefined'?'edit':'add');
    const [facilitySlotPending, setFacilitySlotPending] = useState(false);

    const [initialized, setInitialized] = useState(true);


    useEffect(() => {
        if(_createLock.success === '' || !createLockPending){
            return;
        }
        if(_createLock.success === true){
            let clone = {};
            Object.assign(clone, facility);
            clone.slot_external_id = _createLock.data.localId;
            setFacilitySlot(clone);
            setCreateLockVisible(false);
            setLockVisibleButtonText(lockTexts[false]);
        }
        setCreateLockPending(false);
    },[_createLock]);

    useEffect(() => {
        if(_facilitySlot.success === '' || !facilitySlotPending){
            return;
        }
        if(_facilitySlot.success === true){
            showNotification('success',_facilitySlot.data.id,null,'facilitySlot');
            abortButtonRef.current.click();
        }
    },[_facilitySlot]);
    const onChangeLock = (e,name) => {
        console.log(e);
        switch (name) {
            case 'boxGroupId':
                setBoxGroupId(e.target.value);
                break;
            case 'lockerId':
                setLockerId(e.target.value);
        }
    }

    const onCreateLock = (e) => {
        console.log("boxGroupId: "+boxGroupId+', lockerId:'+lockerId);
        if(boxGroupId !== '' && lockerId !== ''){
            props.dispatch(paketinActions.createLock({
                token: Biscuit.get('token'),
                data: {
                    boxId: boxGroupId,
                    resourceId: lockerId
                }
            }));
            setCreateLockPending(true);
        }
    }

    const onChangeForm = (e,name) => {
        let clone = {};
        Object.assign(clone, facilitySlot);
        clone.set(name,e.target.value);
        setFacilitySlot(clone);
    }

    const onSubmit = () => {
        switch(action){
            case "edit":
                dispatch(facilitySlotActions.editFacilitySlot({
                    token: Biscuit.get('token'),
                    id: facilitySlot.id,
                    body: facilitySlot,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
                setFacilitySlotPending(true);
                break;
            case "add":
                dispatch(facilitySlotActions.addFacilitySlot({
                    token: Biscuit.get('token'),
                    body: facilitySlot,
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                }));
                setFacilitySlotPending(true);
                break;
        }
    }
    const onCreateLockShow = () => {
        const toSet = !createLockVisible;
        setCreateLockVisible(toSet);
        setLockVisibleButtonText(lockTexts[toSet]);
    }

    const close = () => {
        window.location.replace(returnPath);
    }

    const abortButtonRef = React.createRef();
    return (
        <>
            <div className='js-off-canvas-overlay is-overlay-fixed is-visible'></div>
                <div className="off-canvas position-right is-transition-overlap is-open" id="inb-off-canvas" data-off-canvas="85mrb3-off-canvas" data-close-on-click="true" aria-hidden="false">
                    <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
                        <h1 className="inb-page-title">{t(action + '_${a}',{a:name})}</h1>
                        <div className="off-canvas__actions column">
                            <button type="submit" className={"button medium beautify beautify-" + Biscuit.get('user.client_id')+ " button-submit round"} title="Speichern" onClick={onSubmit}>
                                {!facilitySlotPending &&
                                    <>
                                        <i className="fi fi-check"></i>
                                        <span>{t('save')}</span>
                                    </>
                                }
                                {facilitySlotPending &&
                                    <span><img className="rollingLoader" src="assets/img/rolling_loader.svg" />{t('save')}</span>
                                }
                            </button>
                            <a
                                href='#'>
                                <button ref={abortButtonRef} type="button" id="inb-resourcesform-abort-button" className="button hollow secondary right button-abort round" title="Fenster schließen" onClick={() => close()}>
                                    <i className="fi fi-x"> </i>
                                </button>
                            </a>
                        </div>
                    </header>
                   {/* <p className="off-canvas__subtitle off-canvas__header-region">
                        {action === 'edit' && typeof facilitySlot.created !== 'undefined' &&
                            t('created_at') + " " + moment(facilitySlot.created).format('DD.MM.YYYY HH:mm:ss') + " " +
                            t('edited_by') + " " + facilitySlot.created_by_name + " | " +
                            t('last_modified_at') + " " + moment(facilitySlot.modified).format('DD.MM.YYYY HH:mm:ss') + " " +
                            t('edited_by') + " " + facilitySlot.modified_by_name
                        }
                    </p>*/}
                    {initialized && <>    <form className="off-content row">
                        <FormItem
                            name="facility_slot_nbr"
                            inputType="number"
                            min={0}
                            label={name + ' '+t('number',null,'capital')}
                            type="input"
                            value={facilitySlot.facility_slot_nbr}
                            largeWidth={3}
                            mediumWidth={3}
                            smallWidth={6}
                            onChangeHandler={onChangeForm}
                            notTiny={true}
                            extraTopClasses="facility_slot_number_input"/>
                        <FormItem
                            name="external_resource_id"
                            inputType="text"
                            label={t('external_resource_id',null,'capital')}
                            type="input"
                            value={facilitySlot.external_resource_id}
                            largeWidth={3}
                            mediumWidth={3}
                            smallWidth={6}
                            onChangeHandler={onChangeForm}
                            notTiny={true}
                            extraTopClasses=""/>
                        <FormItem
                            name="resource_id"
                            inputType="select"
                            label={t('resource',null,'capital')}
                            type="select"
                            dataKey="id"
                            data={resources}
                            selected={facilitySlot.resource_id !== null?facilitySlot.resource_id:''}
                            largeWidth={6}
                            mediumWidth={6}
                            smallWidth={12}
                            onChangeHandler={onChangeForm}
                            placeholder={t('please_select')}
                            extraTopClasses="resource_select"/>
                        <FormItem
                            name="status"
                            inputType="select"
                            label={t('status',null,'capital')}
                            type="select"
                            dataKey="id"
                            data={[{id: 'active',name: t('active')},{id: 'inactive', name: t('inactive')}]}
                            selected={facilitySlot.status}
                            largeWidth={3}
                            mediumWidth={3}
                            smallWidth={12}
                            onChangeHandler={onChangeForm}
                            placeholder={t('please_select')}
                            extraTopClasses="status_select"/>
                        {facility.facility_type === 'cyclepoint' && <>
                            <FormItem
                                name="error_code"
                                inputType="text"
                                label={t('error_code',null,'capital')}
                                type="input"
                                value={facilitySlot.error_code !== null?facilitySlot.error_code:''}
                                largeWidth={3}
                                mediumWidth={3}
                                smallWidth={6}
                                onChangeHandler={onChangeForm}
                                notTiny={true}
                                extraTopClasses=""/>
                            <FormItem
                                name="error_text"
                                inputType="text"
                                label={t('error_text',null,'capital')}
                                type="input"
                                value={facilitySlot.error_text !== null?facilitySlot.error_text:''}
                                largeWidth={9}
                                mediumWidth={9}
                                smallWidth={12}
                                onChangeHandler={onChangeForm}
                                notTiny={true}
                                extraTopClasses=""/>
                            <FormItem
                                name="charging_state"
                                inputType="text"
                                label={t('charging_state',null,'capital')}
                                type="input"
                                value={facilitySlot.charging_state !== null?facilitySlot.charging_state:''}
                                largeWidth={4}
                                mediumWidth={4}
                                smallWidth={6}
                                onChangeHandler={onChangeForm}
                                notTiny={true}
                                extraTopClasses=""/>
                            <FormItem
                                name="charging_quality"
                                inputType="text"
                                label={t('charging_quality',null,'capital')}
                                type="input"
                                value={facilitySlot.charging_quality !== null?facilitySlot.charging_quality:''}
                                largeWidth={4}
                                mediumWidth={4}
                                smallWidth={6}
                                onChangeHandler={onChangeForm}
                                notTiny={true}
                                extraTopClasses=""/>
                            <FormItem
                                name="lock_open"
                                type="checkbox"
                                label={t('lock_open', null, 'capital')}
                                value={facilitySlot.lock_open === null ? false: facilitySlot.lock_open}
                                largeWidth={4}
                                mediumWidth={4}
                                smallWidth={12}
                                switchStyle={{clear: 'both'}}
                                onChangeHandler={onChangeForm}
                                extraTopClasses=""/>
                        </>
                        },
                        {Biscuit.get('user.is_superuser') === 'true' && facility.facility_type !== 'cyclepoint' && <>
                            <FormItem
                                name="slot_external_id"
                                inputType="text"
                                label={name + ' ' + t('external_id', null, 'capital')}
                                type="input"
                                value={facilitySlot.slot_external_id}
                                largeWidth={3}
                                mediumWidth={5}
                                smallWidth={6}
                                onChangeHandler={onChangeForm}
                                notTiny={true}
                                extraTopClasses=""/>
                            <FormItem
                                name="createLockShow"
                                inputType="button"
                                label={lockVisibleButtonText}
                                link={"#"}
                                type="button"
                                largeWidth={3}
                                mediumWidth={3}
                                smallWidth={6}
                                onChangeHandler={onCreateLockShow}
                                notTiny={true}
                                beautify={true}
                                extraTopClasses=""/>
                            {createLockVisible && <>
                                <FormItem
                                    name="boxGroupId"
                                    inputType="text"
                                    label={t('boxGroupId', null, 'capital')}
                                    type="input"
                                    value={boxGroupId}
                                    largeWidth={4}
                                    mediumWidth={4}
                                    smallWidth={6}
                                    onChangeHandler={onChangeLock}
                                    notTiny={true}
                                    extraTopClasses=""/>
                                <FormItem
                                    name="lockerId"
                                    inputType="text"
                                    label={t('lockerId', null, 'capital')}
                                    type="input"
                                    value={lockerId}
                                    largeWidth={4}
                                    mediumWidth={4}
                                    smallWidth={6}
                                    onChangeHandler={onChangeLock}
                                    notTiny={true}
                                    extraTopClasses=""/>
                                <FormItem
                                    name="createLock"
                                    inputType="button"
                                    label={t('create lock', null, 'capital')}
                                    link={"#"}
                                    type="button"
                                    largeWidth={2}
                                    mediumWidth={2}
                                    smallWidth={6}
                                    beautify={true}
                                    onChangeHandler={onCreateLock}
                                    notTiny={true}
                                    extraTopClasses=""/>
                            </>}
                        </>
                        }
                    </form>
                    </>}
                </div>
            </>
    );
}
export default SlotsItemView;